import React from "react"
import {
  cardContainer,
  innerContainer,
  inputContainer,
  inputBox,
  inputRow,
  inputBoxHigh,
} from "../../personal.module.css"
import { Input } from "src/components/core/atoms/input"
import Card from "src/components/core/atoms/card"

export const JobDetails = ( { input } ) => {
  return (
    <div className={ cardContainer }>
      <Card title="Job Details">
        <div className={ innerContainer }>
          <div className={ inputContainer }>
            <p>Job Reference Number</p>
            <Input.Field
              type="number"
              className={ inputBox }
              name="jobReferenceNumber"
              value={ input.values.jobReferenceNumber }
              onChange={ ( e ) => input.setValues( { ...input.values, jobReferenceNumber: e.target.value } ) }
              placeholder="E.g.: 123456"
            />
            <Input.ErrorMessage name="jobReferenceNumber" input={ input } />
          </div>
        </div>
        <div className={ innerContainer }>
          <div className={ inputContainer }>
            <p>Role Production Company</p>
            <Input.Field
              type="text"
              className={ inputBox }
              name="roleProductionCompany"
              value={ input.values.roleProductionCompany }
              onChange={ ( e ) => input.setValues( { ...input.values, roleProductionCompany: e.target.value } ) }
              placeholder="E.g.: Spinning Reel Ltd."
            />
            <Input.ErrorMessage name="roleProductionCompany" input={ input } />
          </div>
        </div>
        <div className={ innerContainer }>
          <div className={ inputContainer }>
            <p>Crew Size</p>
            <div className={ inputRow }>
              <p>If you don’t know exactly, just give us your best estimate.</p>
              <Input.Select
                name="crewSize"
                input={ input }
                options={ {
                  0: "Please select",
                  10: "Up to 10 personnel",
                  20: "Up to 20 personnel",
                  30: "Up to 30 personnel",
                  40: "Up to 40 personnel",
                  50: "Up to 50 personnel",
                  60: "A lot!",
                } }
              />
            </div>
            <Input.ErrorMessage name="crewSize" input={ input } />
          </div>
        </div>
        <div className={ innerContainer }>
          <div className={ inputContainer }>
            <textarea
              className={ inputBoxHigh }
              name="notes"
              value={ input.values.notes }
              onChange={ ( e ) => input.setValues( {
                ...input.values,
                notes: e.target.value
              } ) }
              placeholder="Additional information (optional)"
              maxLength={ 512 }
            />
          </div>
        </div>
      </Card>
    </div>
  )
}

export default JobDetails